import { Suspense } from 'react';
import cc from 'classcat';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy } from 'utils/generic/lazy';
import { isMobile } from 'utils/is-mobile';
import { Skeleton } from 'newcomponents/UI/Skeleton';
// eslint-disable-next-line import/order
import './lazyWrapperStyles.less';

const { HooryAICard } = lazy(
  () =>
    import(
      /* webpackChunkName: "hoory-ai-compact" */ 'newcomponents/Shared/generic/HooryAI/HooryAICard'
    )
);

const skeletonStyles = isMobile()
  ? {
      width: '100%',
      height: '146px',
      borderRadius: '10px'
    }
  : {
      width: '100%',
      height: '172px',
      borderRadius: '10px'
    };

export const HooryAiCardLazyWrapper = () => {
  return SpringConfigs.HOORY_ENABLED &&
    SpringConfigs.HOORY_ENABLED_SPORTSBOOK_BETSLIP ? (
    <Suspense
      fallback={
        <div
          className={cc([
            'hooryAiCardWrapper',
            { 'hooryAiCardWrapper--mobile': isMobile() }
          ])}
        >
          <Skeleton.Button active style={skeletonStyles} />
        </div>
      }
    >
      <div
        className={cc([
          'hooryAiCardWrapper',
          { 'hooryAiCardWrapper--mobile': isMobile() }
        ])}
      >
        <HooryAICard />
      </div>
    </Suspense>
  ) : null;
};
